import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategoryGrid() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              视频分类
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
              按分类浏览狗头萝莉的精彩视频内容，找到你最喜欢的内容类型
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-lg bg-background-100 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
              >
                <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </span>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors text-center whitespace-nowrap">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-400">
                  {cat.count}个视频
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}